/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';
import {
    JsonUserData,
    JsonUserDataFromJSON,
    JsonUserDataFromJSONTyped,
    JsonUserDataToJSON,
} from './JsonUserData';

/**
 * 
 * @export
 * @interface JsonUser
 */
export interface JsonUser {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonUser
     */
    allowedActions?: Array<JsonUserAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonUser
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonUser
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonUser
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonUser
     */
    loggedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonUser
     */
    partyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonUser
     */
    roleId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonUser
     */
    status?: JsonUserStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonUser
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonUser
     */
    updatedBy?: number;
    /**
     * 
     * @type {JsonUserData}
     * @memberof JsonUser
     */
    userData?: JsonUserData;
    /**
     * 
     * @type {number}
     * @memberof JsonUser
     */
    userId?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonUserAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonUserStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE',
    New = 'NEW'
}

export function JsonUserFromJSON(json: any): JsonUser {
    return JsonUserFromJSONTyped(json, false);
}

export function JsonUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'loggedAt': !exists(json, 'loggedAt') ? undefined : json['loggedAt'],
        'partyId': !exists(json, 'partyId') ? undefined : json['partyId'],
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userData': !exists(json, 'userData') ? undefined : JsonUserDataFromJSON(json['userData']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function JsonUserToJSON(value?: JsonUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'loggedAt': value.loggedAt,
        'partyId': value.partyId,
        'roleId': value.roleId,
        'status': value.status,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userData': JsonUserDataToJSON(value.userData),
        'userId': value.userId,
    };
}

